/**
 * Ensures a URL has a proper protocol, preserving existing protocol if present
 * @param url - The URL to format
 * @returns The URL with proper protocol
 */
export function formatUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') {
    return '#';
  }
  
  // Remove any leading/trailing whitespace
  const cleanUrl = url.trim();
  
  // If the URL already has a protocol (http or https), return as is
  if (cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://')) {
    return cleanUrl;
  }
  
  // If the URL starts with '//', add http: (preserve original intent)
  if (cleanUrl.startsWith('//')) {
    return `http:${cleanUrl}`;
  }
  
  // For URLs without protocol, check if it looks like it should be http or https
  // If no indication, default to http:// to preserve original behavior
  return `http://${cleanUrl}`;
}

/**
 * Checks if a URL is valid and external
 * @param url - The URL to validate
 * @returns Boolean indicating if the URL is valid
 */
export function isValidExternalUrl(url: string | null | undefined): boolean {
  if (!url || typeof url !== 'string') {
    return false;
  }
  
  try {
    const formatted = formatUrl(url);
    const urlObj = new URL(formatted);
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
  } catch {
    return false;
  }
}
